import { useRef, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import FileDownload from "js-file-download";
import { getFileName } from "../../Utils/GetFileName";
import SharedDialog, { SharedDialogControls } from "../../Layout/Dialog/SharedDialog";
import { contactUrls } from "../../URL/ApplicationUrls";
import { removeQuotationMarksFrom } from "../../Utils/strings";
import {
  showNotSelfClosingActionFailureToast,
  showNotSelfClosingActionStartToast,
  showNotSelfClosingActionSuccessToast,
  ToastId,
} from "../../TransportNetwork/NotificationForActionButton";

interface Props {
  readonly isOpen: boolean;
  readonly closeDialog: () => void;
}

export const ContactUploadDialog = ({ isOpen, closeDialog }: Props) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const uploadInput = useRef<HTMLInputElement>(null);
  const toastId: ToastId = useRef(null);

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    toastId.current = showNotSelfClosingActionStartToast("Uploading contacts file");
    closeDialog();
    const formData = new FormData();
    if (selectedFile) {
      formData.append("fileUpload", selectedFile, selectedFile?.name);
    }

    try {
      const response = await axios.postForm(contactUrls.upload, formData, { responseType: "blob" });
      if (response.headers["content-type"]) {
        showNotSelfClosingActionSuccessToast(
          toastId,
          "Contacts file successfully uploaded, please check the log file for errors"
        );
        const filename = getFileName(response);
        FileDownload(response.data, removeQuotationMarksFrom(filename));
      } else {
        showNotSelfClosingActionSuccessToast(toastId, "Contacts file successfully uploaded");
      }
    } catch {
      showNotSelfClosingActionFailureToast(toastId, "Uploading contacts file failed");
    }
  };

  return (
    <SharedDialog
      title="Contact CSV Upload"
      subtitle=""
      isOpen={isOpen}
      handleClose={closeDialog}
      width="md"
    >
      <p>Please, select a file.</p>
      <div style={{ textAlign: "left", padding: "1rem 0" }}>
        <button
          type="button"
          onClick={() => uploadInput.current?.click()}
          className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-primary k-rounded-md"
          style={{
            display: "inline-block",
            cursor: "pointer",
            margin: "0 0.5rem",
          }}
        >
          <FontAwesomeIcon icon={faUpload} /> Contact-Upload: Select file
        </button>
        <input
          style={{ display: "none" }}
          id="file-upload"
          type="file"
          onChange={changeHandler}
          ref={uploadInput}
        />
        {selectedFile?.name}
      </div>
      <SharedDialogControls>
        <button
          onClick={handleSubmit}
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          disabled={!selectedFile}
        >
          Submit
        </button>
        <button
          onClick={closeDialog}
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
        >
          Close
        </button>
      </SharedDialogControls>
    </SharedDialog>
  );
};
